import { render, staticRenderFns } from "./teacherLayout.vue?vue&type=template&id=6a3a1bbb"
import script from "./teacherLayout.vue?vue&type=script&lang=js"
export * from "./teacherLayout.vue?vue&type=script&lang=js"
import style0 from "./teacherLayout.vue?vue&type=style&index=0&id=6a3a1bbb&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports